// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-bqfwf{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-byfkt{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-swcee{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bycjb{grid-column:span 3}.assets-scss-gridstyleGrid-col4-bfzdc{grid-column:span 4}.assets-scss-gridstyleGrid-col9-bneav{grid-column:span 9}.assets-scss-gridstyleGrid-col12-yzqmy{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-dozwl{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-bqfwf",
	"grid": "assets-scss-gridstyleGrid-grid-byfkt",
	"col6": "assets-scss-gridstyleGrid-col6-swcee",
	"col3": "assets-scss-gridstyleGrid-col3-bycjb",
	"col4": "assets-scss-gridstyleGrid-col4-bfzdc",
	"col9": "assets-scss-gridstyleGrid-col9-bneav",
	"col12": "assets-scss-gridstyleGrid-col12-yzqmy",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-dozwl"
};
module.exports = ___CSS_LOADER_EXPORT___;
